import React, { useRef } from 'react';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import CategoryCardComponent from '../../../components/organism/CategoryCardComponent/';
import Box from '../../../components/molecules/Box';
import { preProcessData } from './preprocessData';
import useStyles from './style';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { TICKET_COMPONENT_ID } from '../../../../constants/index';
import { get } from 'lodash';
import { useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { canUseDOM } from '../../../utils/canUseDOM';
import { settings } from './config';
import Typography from '../../../components/atoms/Typography';
import Slider from 'react-slick';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import ButtonMUI from '../../../components/atoms/Button';

const Tickets = props => {
  const theme = useTheme();
  const classes = useStyles();
  const sliderRef = useRef()
  const { fields, params } = props;
  const { ticket } = fields || '';
  const { ticketHeading, ticketStripColor, ticketBackgroundColor } = params || '';
  const editorialGridTabs = preProcessData(
    ticket,
    ticketStripColor,
    ticketBackgroundColor
  );
  const isMobile = canUseDOM && window.innerWidth < 1024;
  const isRTL = theme && theme.direction === 'rtl';
  const ticketsWithUrls = ticket && ticket.filter(item => item?.field?.ticketWebUrl?.value);


  const ticketData = fields?.ticket;


  useEffect(() => {
    if (isRTL && !isMobile) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(sliderRef.current.props.children.length);
      }, 2000);
    }
  }, []);
  const getInitialSlides = () => {
    const length = ticketData && ticketData.length > 0 && ticketData.filter(ticket => ticket?.fields?.ticketTitle?.value && ticket?.fields?.ticketWebUrl?.value).length;
    if (isMobile) {
      return 0;
    }

    else {
      return isRTL ? 2 : 0;
    }
  }

  const hasArrow = () => {
    const length = ticketData && ticketData.length > 0 && ticketData.filter(ticket => ticket?.fields?.ticketTitle?.value && ticket?.fields?.ticketWebUrl?.value).length;
    if (canUseDOM && window.innerWidth > 1510 && length > 3) {
      return true;
    }
    if (canUseDOM && window.innerWidth > 1023 && length > 1) {
      return true;
    }

    if (canUseDOM && window.innerWidth < 1024 && length > 3) {
      return true;
    } else {
      return false;
    }
  }
  const slickSetting = {
    ...settings(),
    rtl: isRTL,
    initialSlide: isRTL ? 2 : 0,
  }

  const sectionTitle = get(fields, 'title.value', '')
  const TicketCard = ({ title, currency, price, url }) => {
    return (
      <div className={classes.cardInner}>
        <div className='contentWrapper'>
          <Typography variant={'body2Bold'}>{title}</Typography>
        </div>
        <div className='borderSection'>
          <div className='border'></div>
        </div>
        <div className='buttonWrapper'>
          <ButtonMUI
            type="button"
            component="a"
            className={'price-cta'}
            buttonType="whitePillContrast"
            size={'small'}
            hasBorder={false}
            href={url}
            target="_blank"
          >
            {getDictionaryText('TicketFind')} {currency} {price}
          </ButtonMUI>
        </div>
      </div>
    )
  }

  return (
    Array.isArray(ticketData) && ticketData.length > 0 ?
      <div className={classes.root} id={TICKET_COMPONENT_ID}>
        <Typography className="heading" variant={'h5Bold'}>{sectionTitle}</Typography>
        <Slider
          ref={sliderRef}
          {...slickSetting}
        >
          {ticketData.map((val) => {
            const title = get(val, 'fields.ticketTitle.value', '')
            const currency = get(val, 'fields.ticketCurrency.value', '')
            const price = get(val, 'fields.ticketPrice.value', '')
            const url = get(val, 'fields.ticketWebUrl.value.href', '')
            return (
              title && url &&
              <TicketCard title={title} currency={currency} price={price} url={url} />
            )
          })}
        </Slider>
      </div> : null
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(Tickets))
);
